import React, { useState } from "react";
import { Typography, Input, Button, Card, message } from "antd";
import { MailOutlined, NumberOutlined } from "@ant-design/icons";
import "./ForgotPassword.css";
import apiClient from "../utils/apiClient";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  /* ================= SEND OTP ================= */
  const handleEmailSubmit = async () => {
    if (!email) {
      message.error("Please enter your email.");
      return;
    }

    if (!isValidEmail(email)) {
      message.error("Invalid email format.");
      return;
    }

    try {
      setLoading(true);

      /* 🔹 CHECK EMAIL */
      const checkData = await apiClient("/auth/check-email/", {
        method: "POST",
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!checkData?.exists) {
        message.error("Email not registered.");
        return;
      }

      /* 🔹 SEND OTP */
      const otpData = await apiClient("/auth/send-otp/", {
        method: "POST",
        body: JSON.stringify({ email: email.trim() }),
      });

      if (otpData?.success === false) {
        throw new Error(otpData?.error || "Failed to send OTP");
      }

      message.success("OTP sent to your email.");
      setStep(2);

    } catch (err) {
      console.error(err);
      message.error(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= VERIFY OTP ================= */
  const handleOtpVerify = async () => {
    if (!otp) {
      message.error("Please enter the OTP.");
      return;
    }

    try {
      setLoading(true);

      const verifyData = await apiClient("/auth/verify-otp/", {
        method: "POST",
        body: JSON.stringify({
          email: email.trim(),
          otp: otp.trim(),
        }),
      });

      if (!verifyData?.success) {
        throw new Error(verifyData?.error || "Invalid OTP");
      }

      message.success("OTP verified successfully!");
      sessionStorage.setItem("reset_email", email.trim());
      window.location.href = "/resetpass";

    } catch (err) {
      console.error(err);
      message.error(err.message || "OTP verification failed.");
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="forgot-password-container">
      <Card className="forgot-password-card" bordered={false}>
        <Title level={3} style={{ textAlign: "center" }}>
          {step === 1 ? "Forgot Password" : "Verify OTP"}
        </Title>

        {step === 1 && (
          <>
            <Text>Enter your email to receive an OTP:</Text>

            <Input
              size="large"
              placeholder="Enter your email"
              prefix={<MailOutlined />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ marginTop: 10 }}
            />

            <Button
              type="primary"
              block
              size="large"
              loading={loading}
              onClick={handleEmailSubmit}
              style={{ marginTop: 15 }}
            >
              Send OTP
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <Text>
              Enter the OTP sent to <b>{email}</b>:
            </Text>

            <Input
              size="large"
              placeholder="Enter OTP"
              prefix={<NumberOutlined />}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{ marginTop: 10 }}
            />

            <Button
              type="primary"
              block
              size="large"
              loading={loading}
              onClick={handleOtpVerify}
              style={{ marginTop: 15 }}
            >
              Verify OTP
            </Button>
          </>
        )}
      </Card>
    </div>
  );
};

export default ForgotPassword;
